import { render, staticRenderFns } from "./DocumentSettingsGenre.vue?vue&type=template&id=4fb0dc1f&scoped=true&"
import script from "./DocumentSettingsGenre.vue?vue&type=script&lang=js&"
export * from "./DocumentSettingsGenre.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSettingsGenre.vue?vue&type=style&index=0&id=4fb0dc1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0dc1f",
  null
  
)

export default component.exports